const ANYTIME_CAFE_TERMINAL_IDS = [8729, 8730];
const FREEDOM_FRIDGE_IDS = [7896, 8894, 9731, 10519, 10731];

const KASPI_DISABLED_TERMINAL_IDS = [...ANYTIME_CAFE_TERMINAL_IDS];

const KASPI_AVAILABLE_BRAND_IDS = [
	'1',
	'5',
	'7',
	'9',
	'11',
	'13',
	'18',
	'21',
	'30',
	'32',
	'36',
	'38',
	'153',
	'50',
	'42',
	'44',
	'75',
	'120',
	'112',
	'114',
	'134',
	'141',
	'79',
	'147',
	'161',
	'73',
	'94',
	'189'
];

const isWebView = () => {
	return !!window.RahmetApp;
};

export const isKaspiDisabled = (terminalId: number, isFridge = false) => {
	if (isWebView()) {
		if (isFridge) {
			return !!FREEDOM_FRIDGE_IDS.includes(terminalId);
		}

		return true;
	}

	if (!!window.ReactNativeWebView) {
		return !KASPI_AVAILABLE_BRAND_IDS.includes(
			window.ReactNativeWebView.brand_id
		);
	}

	return !!KASPI_DISABLED_TERMINAL_IDS.includes(terminalId);
};

export const isOnlyKaspiAvailable = (terminalId: number) => {
	const EXCLUDED_TERMINAL_IDS = [
		8199, 8198, 9623, 9624, 9766, 10533, 10534, 10536, 10552, 10553, 10554,
		10555, 10556, 10557, 10403, 10402, 10645, 9560, 9550, 10644
	];

	return EXCLUDED_TERMINAL_IDS.includes(terminalId);
};
